import { InputHTMLAttributes, useEffect, useRef, useState } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> & {
    value: number;
    onValueChange: (value: number) => void;
};

export default function NumberInput({ value, onValueChange, ...props }: Props) {
    const [draft, setDraft] = useState(String(value));
    const lastValue = useRef(value);

    useEffect(() => {
        if (value !== lastValue.current) {
            setDraft(String(value));
            lastValue.current = value;
        }
    }, [value]);

    return <input {...props} type="number" value={draft} onChange={event => {
        const raw = event.target.value;
        setDraft(raw);
        const next = Number(raw);
        if (Number.isFinite(next)) {
            lastValue.current = next;
            onValueChange(next);
        }
    }} />;
}
